import { render, staticRenderFns } from "./service-catalog-custom-field.vue?vue&type=template&id=2b436769&"
import script from "./service-catalog-custom-field.vue?vue&type=script&lang=js&"
export * from "./service-catalog-custom-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports